import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectTypeColorsFetched, {
	type SubjectTypeColorsFetchedAction,
	type SubjectTypeColorsFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeColorsFetched';
import subjectTypeColorsFetchFailed, {
	type SubjectTypeColorsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeColorsFetchFailed';
import type FetchSubjectTypeColors from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectTypeColors';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeColorsFetchedAction | SubjectTypeColorsFetchFailedAction;

export default (_query: FetchSubjectTypeColors) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectTypeColorsFetchedPayload>(
				`${parameters.api.host}/api/enums/subject-type-colors`,
			);

			const action = subjectTypeColorsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeColorsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
